
    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"lineConsolidatedOEE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeScrap"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consolidatedData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeScrap"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeScrap"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oee1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oee2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oee3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tcu"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalEquipmentTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mannedTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productionTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operatingTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valuedOperatingTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"speedLoss"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scrapLoss"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stopsData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stopStats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StopStats"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":525}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/stop-stats.gql\'\\n\\nquery lineConsolidatedOEE($lineIds: [ID!], $time: Time!, $includeScrap: Boolean = true) {\\n  consolidatedData(lineIds: $lineIds, time: $time) {\\n    oee(includeScrap: $includeScrap) {\\n      oee1\\n      oee2\\n      oee3\\n      tcu\\n      totalEquipmentTime\\n      mannedTime\\n      productionTime\\n      operatingTime\\n      valuedOperatingTime\\n      speedLoss\\n      scrapLoss\\n    }\\n\\n    stopsData {\\n      _id: lineId\\n      lineId\\n      stopStats {\\n        ...StopStats\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('@/graphql/fragments/stop-stats.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["lineConsolidatedOEE"] = oneQuery(doc, "lineConsolidatedOEE");
        
